import * as yup from "yup";

export const passwordSchema = yup.object().shape({
    oldPassword: yup.string().notRequired().nullable(),
    password: yup.string().notRequired().nullable().notOneOf([yup.ref('oldPassword')], 'New password must be different from the old password'),
    confirmPassword: yup.string().notRequired().nullable().oneOf([yup.ref('password')], 'Confirm Passwords must match'),
  });